import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
// DO NOT change the loadable as it will break SSR on view page
export const AIFloatingContextMenuLoadable: LoadableType<{
	contentId: string;
	contentType: string;
	spaceKey: string;
	lastModifiedDate?: string | null;
	pageCommentsSectionInView?: boolean;
	isLivePage?: boolean;
	isInObjectSideBar?: boolean;
	contentIdFromQuery?: string | null;
	contentBodyDynamic?: {
		representation?: string | null;
		value?: string | null;
	} | null;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AIFloatingContextMenu" */ './AIFloatingContextMenu.ts'
			)
		).AIFloatingContextMenu,
});
